import { composeClassNames, getImageUrl } from "@faedev/editor-utils";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Dropdown,
  Image,
  NavDropdown,
  Navbar,
} from "react-bootstrap";
import { useCookies } from "react-cookie";
import MenuMain from "src/components/MenuMain";
import MqLteTablet from "src/components/MqLteTablet";
import Search from "src/components/Search";
import Translate from "src/components/Translate";
import constants from "src/constants";
import getLink from "src/functions/getLink";
import Cart from "src/icons/Cart";
import Small_cancel from "src/icons/Small-cancel";
import { sAlert } from "src/styles/sAlert.module.scss";
import { sButton } from "src/styles/sButton.module.scss";
import { sButtonClose } from "src/styles/sButtonClose.module.scss";
import { sDropdownItem } from "src/styles/sDropdownItem.module.scss";
import { sDropdownMembers } from "src/styles/sDropdownMembers.module.scss";
import { sLogo } from "src/styles/sLogo.module.scss";
import { sMenuMainLinkCircle } from "src/styles/sMenuMainLinkCircle.module.scss";
import { sNavbar } from "src/styles/sNavbar.module.scss";
import { sNavbarCollapse } from "src/styles/sNavbarCollapse.module.scss";
import { sNavbarToggle } from "src/styles/sNavbarToggle.module.scss";
import { sQuickPlay } from "src/styles/sQuickPlay.module.scss";

function Header() {
  const { locale: lang, push, pathname } = useRouter();
  const [cookies, setCookie] = useCookies(["alertSell"]);
  const [alertResetPassword, setAlertResetPassword] = useState(false);

  useEffect(() => {
    const timeId = setTimeout(() => {
      // After 10 seconds set the show value to false
      setAlertResetPassword(false);
    }, 10000);

    return () => {
      clearTimeout(timeId);
    };
  }, [alertResetPassword]);

  return (
    <>
      <Navbar expand={`lg`} sticky={`top`} className={sNavbar}>
        <Link href={"/"} passHref>
          <Navbar.Brand href={`/` + constants.Locales._default.lang + `/`}>
            <Image
              src={getImageUrl("/images/logotypes/logo_vivido.svg")}
              className={sLogo}
              alt="Vivido logo"
            />
          </Navbar.Brand>
        </Link>
        {constants.Show.navQuickplay ? (
          <Button
            variant="link"
            className={sQuickPlay}
            style={{ padding: "0" }}
          >
            <Image
              src={getImageUrl("/images/quick-play.svg")}
              alt="Quick play"
            />
          </Button>
        ) : null}
        <div className="mx-auto">
          <MqLteTablet>
            <NavDropdown
              id={`membershipMenu`}
              className={composeClassNames([sDropdownMembers, "item-members"])}
              title={
                <Button
                  className={composeClassNames([sButton])}
                  size="sm"
                  type="button"
                  variant={pathname !== `/members` ? `dark` : `light`}
                >
                  <span className="text">
                    <Translate tKey={`Try membership`} />
                  </span>
                  <span className="text-short">
                    <Translate tKey={`Try us`} />
                  </span>
                </Button>
              }
            >
              <Link href={getLink(lang, `companies`)} passHref>
                <Dropdown.Item className={sDropdownItem}>
                  <Translate tKey={`For companies`} />
                </Dropdown.Item>
              </Link>
              <Dropdown.Divider />
              <Link href={getLink(lang, `members`)} passHref>
                <Dropdown.Item className={sDropdownItem}>
                  <Translate tKey={`For users`} />
                </Dropdown.Item>
              </Link>
              <Dropdown.Divider />
              <Link href={getLink(lang, `instructors`)} passHref>
                <Dropdown.Item className={sDropdownItem}>
                  <Translate tKey={`For instructors`} />
                </Dropdown.Item>
              </Link>
            </NavDropdown>
          </MqLteTablet>
        </div>
        <Navbar.Toggle
          className={sNavbarToggle}
          style={{ padding: "0" }}
        ></Navbar.Toggle>
        {constants.Show.sale ? (
          <Link href={getLink(lang, `cart`, null)} passHref>
            <Button
              variant="primary"
              className={composeClassNames([sButton, "btn-cart"])}
              size="sm"
            >
              <Cart />
            </Button>
          </Link>
        ) : null}
        <Navbar.Collapse className={sNavbarCollapse}>
          {constants.Show.navSearch ? <Search /> : null}
          <MenuMain setAlertResetPassword={setAlertResetPassword} />
        </Navbar.Collapse>
      </Navbar>
      {constants.Marketing.showPromoAlert && (
        <div>
          {!cookies.alertSell ? (
            <Alert
              variant={`info`}
              className={composeClassNames([sAlert, "alert-flash"])}
            >
              <strong className="mr-3">
                <Translate
                  tKey={`Yoga instructor, therapist, studio or festival? Join us and enjoy a large number of benefits.`}
                />
              </strong>
              <Button
                className={composeClassNames([
                  sButton,
                  sMenuMainLinkCircle,
                  "btn-cta",
                ])}
                onClick={() => push(constants.Paths.joinUs)}
                size="sm"
                variant="primary"
              >
                <Translate tKey={`Become an Vivido instructor`} />
              </Button>
              <Button
                className={composeClassNames([sButtonClose, `btn-close`])}
                onClick={() => setCookie(`alertSell`, false, { path: "/" })}
                size="sm"
                variant="link"
              >
                <Small_cancel />
              </Button>
            </Alert>
          ) : (
            <></>
          )}
        </div>
      )}
      {alertResetPassword && (
        <Alert variant="success" className={sAlert}>
          <Translate
            tKey={`A password reset link has been sent to the email.`}
          />
        </Alert>
      )}
    </>
  );
}

export default Header;
